<script lang="ts" setup>
import { computed, ref, watch, whenever, useIntercom, useCookieConsent } from '#imports'

const { boot, hasConsent, showCookieNotice, isUnavailableNoticeVisible, isBooted, isIntercomEnabled } = useIntercom()
const { isConsentReady, isConsentResolved } = useCookieConsent()

// Latch: parent must not unmount the step while its v-model watcher is still pending — the step needs to close itself via close().
const cookieNoticeMounted = ref(false)
whenever(showCookieNotice, () => {
    cookieNoticeMounted.value = true
}, { immediate: true })

const unavailableNoticeMounted = ref(false)
whenever(isUnavailableNoticeVisible, () => {
    unavailableNoticeMounted.value = true
}, { immediate: true })

const showIntercomIcon = computed(() => {
    if (!isIntercomEnabled.value) return false
    if (!isConsentResolved.value) return false

    return !hasConsent.value
})

const shouldShowIntercom = computed(() => isIntercomEnabled.value && isConsentReady.value && hasConsent.value)

if (import.meta.client) {
    watch(shouldShowIntercom, async (isActive) => {
        if (isActive) {
            if (!isBooted.value) {
                await boot()
            }

            return
        }

        if (isBooted.value) {
            const { shutdown } = await import('@intercom/messenger-js-sdk')
            shutdown()
        }
        isBooted.value = false
    }, { immediate: true })
}
</script>

<template>
    <ClientOnly>
        <LazyUIIntercomChatIcon v-if="showIntercomIcon" />
        <LazyUICookieNotice v-if="cookieNoticeMounted" />
        <LazyUIIntercomUnavailableNotice v-if="unavailableNoticeMounted" />
    </ClientOnly>
</template>
